<script>
import Layout from '@layouts/main'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import AppConfigService from '@src/services/config'


export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      config: AppConfigService.config,
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            username: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false

          location.href = appConfig.baseUrl + "dashboard" ;
          // Redirect to the originally requested page, or to the home page
          //this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>

<template>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="card-group">
                <div class="card p-4">
                    <div class="card-body">
                       <div class="logo-wrap"><img class="nav-logo" src="../../assets/images/UPlogo.png" /></div>
                        <h1>Přihlášení</h1>
                        
                        <p class="text-muted"></p>
                        <form  @submit.prevent="tryToLogIn">
                          <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <font-awesome-icon :icon="['fas', 'user']" class="icon alt" />
                                    </span>
                                </div>
                                <input class="form-control" type="text" v-model="username" placeholder="Přihlašovací jméno">
                            </div>
                            <div class="input-group mb-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <font-awesome-icon :icon="['fas', 'lock']" class="icon alt" />
                                    </span>
                                </div>
                                <input class="form-control" type="password" v-model="password" placeholder="Heslo">
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <button class="btn btn-primary px-4" :disabled="tryingToLogIn" type="submit">Přihlásit se 
                                      <BaseIcon v-if="tryingToLogIn" name="sync" spin /></button>
                                </div>
                                <!-- <div class="col-6 text-right">
                                    <button class="btn btn-link px-0" type="button">Forgot password?</button>
                                </div> -->
                            </div>
                        </form>
                    </div>
                </div>
                <!-- <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
                    <div class="card-body text-center">
                        <div>
                            <h2>Sign up</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            <button class="btn btn-primary active mt-3" type="button">Register Now!</button>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div> 
  </div>

            <!-- Start Login -->
            <!-- <section class="login-wrapper">
                <div class="inner">
                    <div class="login">
                        <div class="login-logo"> <a href="index.html"><img src="images/login-logo.png" class="img-responsive" alt=""></a> </div>
                        <div class="head-block">
                            <h1>LOGIN  Now</h1>
                        </div>
                        <div class="cnt-block">
                            <form @submit.prevent="tryToLogIn" class="form-outer">
                                <input name="Username or Email" type="text" placeholder="Username or Email">
                                <BaseInput
                                  v-model="username"
                                  name="username"
                                  :placeholder="placeholders.username"
                                />
                               <BaseInput
                                  v-model="password"
                                  name="password"
                                  type="password"
                                  :placeholder="placeholders.password"
                                />
                                      <p v-if="authError">
        There was an error logging in to your account.
      </p>
                                <div class="button-outer">
                                    <button class="btn" :disabled="tryingToLogIn" type="submit">Login now <BaseIcon v-if="tryingToLogIn" name="sync" spin /></button>
                                    <div class="or hidden-xs">or</div>
                                    <button class="btn register">Register now <span class="icon-more-icon"></span></button>
                                </div>
                                <div class="remember">
                                    <div class="check">
                                        <input type="checkbox" id="test1" />
                                        <label for="test1">Remember me</label>
                                    </div>
                                    <a href="#" class="forgot"><span>?</span>Forgot password</a> </div>
                            </form>
                        </div>
                        <div class="login-footer">
                            <ul class="follow-us clearfix">
                                <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                                <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                                <li><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                                <li><a href="#"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                                <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            End Login --> 


</template>

<style lang="scss">
@import '@design';


.main {
    margin-left: 0 !important;
}

.form {
  text-align: center;
}

h1 {
  font-size: 28px;
  text-align: center;
}

.logo-wrap {
  text-align: center;

  img {
    padding: 40px;
    max-height: 200px;
  }
}

</style>
